<app-locked-action [locked]="isAccountLimited">
  <button
    class="btn"
    [class.btn--outlined]="type === 'button'"
    [class.btn--icon]="type === 'icon'"
    [class.btn--icon-borage]="type === 'icon'"
    [disabled]="disableButton$ | async"
    (click)="onOpenMessagesModalClick()">
    <svg class="icon btn__icon" width="16" height="16">
      <use xlink:href="#messages"></use>
    </svg>

    @if (type === 'button') {
      <span class="btn__text">
        {{ 'MESSAGES.OPEN_MODAL_BUTTON' | translate }}
      </span>
    }
  </button>
</app-locked-action>
